/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconProfileEducation = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M8.136 8.965a.464.464 0 0 1-.22-.056l-6.5-3.5a.464.464 0 0 1 0-.818l6.5-3.5a.464.464 0 0 1 .44 0l6.5 3.5a.464.464 0 0 1 0 .818l-6.5 3.5a.464.464 0 0 1-.22.056z"
    />
    <path
      fill="currentColor"
      d="M3 7.892v3c0 .012.012.019.013.03-.002.027-.013.051-.013.077 0 1.683 2.196 3 5 3s5-1.317 5-3c0-.026-.012-.05-.013-.077.001-.011.013-.018.013-.03V7.384L8.356 9.909a.46.46 0 0 1-.44 0L3 7.271v.621zM15 16a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5zM16 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
    />
  </svg>
);

IconProfileEducation.displayName = 'IconProfileEducation';

IconProfileEducation.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconProfileEducation);
IconProfileEducation.displayName = 'IconProfileEducation';
